import React, { useState, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

import './SignUp.css'
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import { isEmail } from "validator";
import { register } from '../../redux/actions/auth';
import { Fragment } from "react";
import Nav from '../Nav/nav'

const required = (value) => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        Kolom tidak boleh kosong!
      </div>
    );
  }
};

const validEmail = (value) => {
  if (!isEmail(value)) {
    return (
      <div className="alert alert-danger" role="alert">
        Email Anda tidak valid!
      </div>
    );
  }
};

const validPassword = (value) => {
  if (value.length < 6 || value.length > 40) {
    return (
      <div className="alert alert-danger" role="alert">
        Password tidak boleh kurang dari 6 karakter
      </div>
    );
  }
};

const validConfirmPassword = (value) => {
  if (value.length < 6 || value.length > 40) {
    return (
      <div className="alert alert-danger" role="alert">
        Password tidak boleh kurang dari 6 karakter
      </div>
    );
  }
};

const Register = () => {
  const form = useRef();
  const checkBtn = useRef();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [successful, setSuccessful] = useState(false);

  const { message } = useSelector(state => state.message);
  const dispatch = useDispatch();

  const onChangeEmail = (e) => {
    const email = e.target.value;
    setEmail(email);
  };

  const onChangePassword = (e) => {
    const password = e.target.value;
    setPassword(password);
  };

  const onChangeConfirmPassword = (e) => {
    const password = e.target.value;
    setConfirmPassword(password);
  };

  const handleRegister = (e) => {
    e.preventDefault();

    console.log('test');

    setSuccessful(false);

    form.current.validateAll();

    console.log(checkBtn.current.context._errors.length, 'ping')
    if (checkBtn.current.context._errors.length === 0) {
      console.log('apa');
      dispatch(register(email, password, confirmPassword))
        .then(() => {
          setSuccessful(true);
        })
        .catch(() => {
          setSuccessful(false);
        });
      console.log('test')
    }
  };

  return (
    <Fragment>
      <Nav />
      <div className="register-background">
        <div className="register-container">
          <div className="wrapper">
            <div className="title"><span>Daftar</span></div>
            <Form onSubmit={handleRegister} ref={form}>
              {!successful && (
                <div>
                  <div className="row">
                    <label htmlFor="email">Alamat e-mail</label>
                    <Input
                      type="text"
                      className="form-control"
                      placeholder="Masukkan alamat e-mail"
                      name="email"
                      value={email}
                      onChange={onChangeEmail}
                      validations={[required, validEmail]}
                    />
                  </div>

                  <div className="row">
                    <label htmlFor="password">Buat kata sandi</label>
                    <Input
                      type="password"
                      className="form-control"
                      placeholder="Masukkan kata sandi"
                      name="password"
                      value={password}
                      onChange={onChangePassword}
                      validations={[required, validPassword]}
                    />
                  </div>

                  <div className="row">
                    <label htmlFor="confirm-password">Konfirmasi kata sandi</label>
                    <Input
                      type="password"
                      className="form-control"
                      placeholder="Ketik ulang kata sandi"
                      name="confirm-password"
                      value={confirmPassword}
                      onChange={onChangeConfirmPassword}
                      validations={[required, validConfirmPassword]}
                    />
                  </div>

                  <div className="row button">
                    <button className="btn-reg-page">
                      <span>Buat Akun</span>
                    </button>
                  </div>
                </div>
              )}

              {message && (

                <div className={successful ? "alert alert-success" : "alert alert-danger"}
                  role="alert">
                  {message}</div>
              )}

              <CheckButton style={{ display: "none" }} ref={checkBtn} />

              <div className="signup-link">
                Sudah mempunyai akun? <Link to="/masuk">Masuk di sini</Link>
              </div>

            </Form>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Register;
